import { useEffect, useState } from 'react';
import { dismissUpdate, onSwUpdate, reloadForUpdate } from '../lib/sw';
import { Button } from './Button';

/** Shown when a new service worker has installed behind the running app. */
export function UpdateToast() {
  const [needRefresh, setNeedRefresh] = useState(false);
  useEffect(() => onSwUpdate(setNeedRefresh), []);

  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-20 z-20 mx-auto flex max-w-md items-center gap-3 rounded-xl border border-line bg-white p-3 shadow-lg"
    >
      <p className="flex-1 text-sm">A new version of FewerBags is available.</p>
      <Button block={false} onClick={reloadForUpdate}>
        Reload
      </Button>
      <button className="text-sm text-muted" onClick={dismissUpdate}>
        Later
      </button>
    </div>
  );
}
